/**
* Based on GitHub Dark theme
*/

.prism-code-editor {
	font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
	--pce-cursor: #2f81f7;
	--pce-bg: #0d1117;
	--pce-widget-border: #303741;
	--pce-widget-bg: #161b22;
	--pce-widget-color: #b8bfc7;
	--pce-widget-color-active: #fff;
	--pce-widget-color-options: #7d8590;
	--pce-widget-bg-input: #0d1117;
	--pce-widget-bg-hover: #5a5d5e4f;
	--pce-widget-bg-active: #1f6feb66;
	--pce-widget-focus: #007acc;
	--pce-search-match: #f2cc6080;
	--pce-widget-bg-error: #5a1d1d;
	--pce-widget-error: #be1100;
	--pce-bg-highlight: #6e76811a;
	--pce-selection-match: #3fb95040;
	--pce-line-number: #6e7681;
	--pce-scrollbar: 210, 10%, 32%;
	--pce-bg-fold: #7d8590;
	--pce-guide-indent: #e6edf31f;
	--pce-ac-icon-class: #f0883e;
	--pce-ac-icon-enum: #f0883e;
	--pce-ac-icon-event: #6e7681;
	--pce-ac-icon-function: #bc8cff;
	--pce-ac-icon-interface: #f0883e;
	--pce-ac-icon-keyword: #ff7b72;
	--pce-ac-icon-namespace: #ff7b72;
	--pce-ac-icon-parameter: #79c0ff;
	--pce-ac-icon-property: #f0883e;
	--pce-ac-icon-snippet: #58a6ff;
	--pce-ac-icon-text: #79c0ff;
	--pce-ac-icon-unit: #58a6ff;
	--pce-ac-icon-variable: #f0883e;
	--pce-selection: #264f78;
	color-scheme: dark;
}

.pce-match {
	--pce-search-match: #8c8d6c;
}

.active-line {
	--pce-line-number: #e6edf3;
}

.active-indent {
	--pce-guide-indent: #e6edf33d;
}

[class*="language-"],
.token.url > .operator,
.token.punctuation,
.token.attr-equals,
.token.code.keyword {
	color: #e6edf3;
}

.token.atrule,
.token.variable,
.language-css .url,
.token.parameter,
.token.list,
.token.class-name,
.token.maybe-class-name {
	color: #ffa657;
}

.token.atrule .rule,
.token.unit,
.token.selector .combinator,
.token.operator,
.token.deleted,
.token.entity,
.token.regex-flags,
.token.token.anchor,
.token.number.quantifier,
.token.keyword {
	color: #ff7b72;
}

.token.tag,
.token.inserted,
.token.selector,
.token.doctype-tag,
.language-regex .escape {
	color: #7ee787;
}

.token.attr-value,
.token.string,
.token.char,
.token.regex,
.language-regex,
.token.string-property,
.token.url > .content, 
.token.url > .variable {
	color: #a5d6ff;
}

.token.builtin,
.token.selector .class,
.token.selector .id,
.token.pseudo-class,
.token.pseudo-element,
.token.attr-name,
.language-css .token.property,
.token.number,
.token.color,
.token.boolean,
.token.constant,
.token.title.important,
.title.important .punctuation,
.language-css .token.function,
.token.code.code-snippet,
.token.doctype,
.token.property-access,
.token.keyword-null,
.token.keyword-this,
.token.char-class,
.token.char-set,
.token.regex .punctuation {
	color: #79c0ff;
}

.token.function {
	color: #d2a8ff;
}

.token.comment,
.token.prolog,
.token.cdata {
	color: #8b949e;
}

.token.important,
.token.bold {
	font-weight: bold;
}

.token.italic {
	font-style: italic;
}

/* Brackets */

.token.bracket-level-0,
.token.bracket-level-6 {
	color: #79c0ff;
}

.token.bracket-level-1,
.token.bracket-level-7 {
	color: #56d364;
}

.token.bracket-level-2,
.token.bracket-level-8 {
	color: #e3b341;
}

.token.bracket-level-3,
.token.bracket-level-9 {
	color: #ffa198;
}

.token.bracket-level-4,
.token.bracket-level-10 {
	color: #ff9bce;
}

.token.bracket-level-5,
.token.bracket-level-11 {
	color: #d2a8ff;
}

.token.interpolation-punctuation {
	color: #a5d6ff;
}

.token.bracket-error {
	color: #7d8590;
}

.token.markup-bracket {
	color: inherit;
}

.active-bracket {
	box-shadow: inset 0 0 0 1px #3fb95099, inset 0 0 0 9in #3fb95040;
}

.active-tagname,
.word-matches span {
	box-shadow: inset 0 0 0 1px #6e768199, inset 0 0 0 9in #6e768180;
}
